/**
 * Mapeia o `state` cru do conector (string do Hub OCPP) para o tom do
 * `StatusPill` + label PT-BR.
 *
 * Estados vêm de `_connector_state_for_evse` no backend (stations/router).
 * `null` significa Hub indisponível ou charger desconhecido.
 */

type Tone = 'green' | 'blue' | 'amber' | 'red' | 'muted';

export interface ConnectorStateInfo {
  tone: Tone;
  label: string;
}

const MAP: Record<string, ConnectorStateInfo> = {
  Available: { tone: 'green', label: 'Disponível' },
  Preparing: { tone: 'amber', label: 'Aguardando início' },
  Charging: { tone: 'blue', label: 'Em uso' },
  SuspendedEV: { tone: 'blue', label: 'Em uso (pausado)' },
  SuspendedEVSE: { tone: 'blue', label: 'Em uso (pausado)' },
  Finishing: { tone: 'amber', label: 'Finalizando' },
  Reserved: { tone: 'amber', label: 'Reservado' },
  Faulted: { tone: 'red', label: 'Indisponível' },
  Unavailable: { tone: 'muted', label: 'Indisponível' },
  // Valores em UPPERCASE também aparecem (Hub Gateway às vezes normaliza)
  AVAILABLE: { tone: 'green', label: 'Disponível' },
  PREPARING: { tone: 'amber', label: 'Aguardando início' },
  CHARGING: { tone: 'blue', label: 'Em uso' },
  FINISHING: { tone: 'amber', label: 'Finalizando' },
  FAULTED: { tone: 'red', label: 'Indisponível' },
  UNAVAILABLE: { tone: 'muted', label: 'Indisponível' },
  OCCUPIED: { tone: 'blue', label: 'Em uso' },
  OFFLINE: { tone: 'muted', label: 'Sem comunicação' }
};

export function mapConnectorState(state: string | null): ConnectorStateInfo {
  if (state == null) {
    return { tone: 'muted', label: 'Sem comunicação' };
  }
  return MAP[state] ?? { tone: 'muted', label: state };
}

/** True quando o conector está livre (motorista pode plugar agora). */
export function isAvailable(state: string | null): boolean {
  if (state == null) return false;
  const upper = state.toUpperCase();
  return upper === 'AVAILABLE' || upper === 'PREPARING';
}
